import { excludeNullOrUndefined } from 'checkout/utils'
import { useAppSelector } from 'hooks/reduxHooks'
import getOfferListKey from 'lib/offer/offerListKey'
import { useMemo } from 'react'

function useOfferMetaDataList(filters?: App.OfferListFilters): Array<App.OfferListMetaData> {
  const offerMetaDataKey = getOfferListKey(filters ?? {})
  const offerMetaData = useAppSelector(state => state.offer.searchResultMetadata.offerMetaData[offerMetaDataKey])

  return useMemo(() => Object.values(offerMetaData ?? {}).filter(excludeNullOrUndefined), [offerMetaData])
}

export default useOfferMetaDataList
